import { ViewerCapabilities } from "./annotator";

// --- CONFIGURATION SECTION ---

/**
 * predefined scenarios of capabilities for the viewer
 * READ_ONLY: only measure, download and view annotations
 * REVIEWER: can annotate, measure, download and delete annotations but not upload or use xfdf format
 * ADMIN: all capabilities enabled
 */
export const ANNOTATOR_SCENARIOS: { [key: string]: ViewerCapabilities } = {
    READ_ONLY: {
        canAnnotate: false,
        canMeasure: true,
        canUpload: false,
        canXfdf: false,
        canDownload: true,
        canDelete: false
    },
    REVIEWER: {
        canAnnotate: true,
        canMeasure: true,
        canUpload: false,
        canXfdf: true,
        canDownload: true,
        canDelete: true
    },
    ADMIN: { 
        canAnnotate: true,
        canMeasure: true,
        canUpload: true,
        canXfdf: true,
        canDownload: true,
        canDelete: true
    }
};


/**
 * Use library events: 
 * Added an onChange event emitter to AnnotationManager that fires 
 * AnnotationChangeEvent with type: 'add' | 'modify' | 'delete' and the affected annotation. 
 * Host apps subscribe via manager.onChange((event) => { ... }) 
 * and unsubscribe by calling the returned function.
 */

export interface PdfXfdfAnnotationChanges {
    content: string,
    action: string,
    legacy: boolean
}